import SddfFileUploader from "@/sddf/SddfFileUploader.vue"

export default {
    el: '#vue-container',
    components: {
        SddfFileUploader,
    },
}
